import {Button, FormControl, FormField, IconButton} from 'platform/components';
import {Box, HStack, VStack} from 'platform/foundation';

import {useFieldArray} from 'react-hook-form';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

import {
  EMPTY_DTC_CODE,
  MazdaAdditionalInformationFormType,
} from '../schemas/mazdaAdditionalInformationFormSchema';

interface MazdaDtcCodeListProps extends TestIdProps {
  control: FormControl<MazdaAdditionalInformationFormType>;
  isDisabled?: boolean;
}

export function MazdaDtcCodeList(props: MazdaDtcCodeListProps) {
  const {fields, append, remove} = useFieldArray({
    control: props.control,
    name: 'dtcCodes',
  });

  return (
    <VStack spacing={4}>
      {fields.map((field, index) => (
        <HStack key={field.id} spacing={4} align="flex-end">
          <Box flex={1}>
            <FormField
              control={props.control}
              name={`dtcCodes.${index}.value`}
              type="text"
              label={isFirstItem(index) ? i18n.t('entity.serviceOrder.labels.dtcCode') : undefined}
              isDisabled={props.isDisabled}
              data-testid={suffixTestId(`dtcCode-[${index}]`, props)}
            />
          </Box>
          <IconButton
            icon="action/delete"
            severity="danger"
            aria-label={i18n.t('general.actions.remove')}
            isDisabled={props.isDisabled}
            onClick={() => remove(index)}
            data-testid={suffixTestId(`removeDtcCode-[${index}]`, props)}
          />
        </HStack>
      ))}
      <HStack>
        <Button
          variant="link"
          size="small"
          leftIcon="content/add_circle"
          title={i18n.t('general.actions.addNew')}
          isDisabled={props.isDisabled}
          onClick={() => append(EMPTY_DTC_CODE)}
          data-testid={suffixTestId('addDtcCode', props)}
        />
      </HStack>
    </VStack>
  );
}

const isFirstItem = (index: number) => index === 0;
